import Api from '@/services/Api'

export default {
  index (params) {
    return Api().post('customerAccount', params)
  },
  create (params) {
    return Api().post('customerAccountNew', params)
  },
  show (params) {
    return Api().post('customerAccountEdit', params)
  },
  state (params) {
    return Api().post('customerAccountState', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/CustomerAccountService.js